import { render, staticRenderFns } from "./CourseBlock.vue?vue&type=template&id=21108589&scoped=true&"
import script from "./CourseBlock.vue?vue&type=script&lang=ts&"
export * from "./CourseBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBlock.vue?vue&type=style&index=0&id=21108589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21108589",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
